import { render, staticRenderFns } from "./Signi_ins.vue?vue&type=template&id=22fe1e60&scoped=true&"
import script from "./Signi_ins.vue?vue&type=script&lang=js&"
export * from "./Signi_ins.vue?vue&type=script&lang=js&"
import style0 from "./Signi_ins.vue?vue&type=style&index=0&id=22fe1e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe1e60",
  null
  
)

export default component.exports